import React, { ReactNode } from 'react';

import { Typography } from '@sravni/react-design-system';

import styles from './styles.module.scss';

interface Props {
  title: string;
  children?: ReactNode;
}

export const FromBlock: React.FC<Props> = ({ title, children }) => {
  return (
    <div className={styles.wrapper}>
      <Typography.Heading level={4} className={styles.title}>
        {title}
      </Typography.Heading>
      {children}
    </div>
  );
};
